import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f50ed116&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f50ed116&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50ed116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f50ed116')) {
      api.createRecord('f50ed116', component.options)
    } else {
      api.reload('f50ed116', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f50ed116&scoped=true", function () {
      api.rerender('f50ed116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/csg/change/index.vue"
export default component.exports